(function () {
  function getSignupHero() {
    return document.querySelector('.waitlist-step-form');
  }

  function openSignupHero() {
    const hero = getSignupHero();
    if (!hero) return;
    hero.style.display = 'flex';
  }

  function closeSignupHero() {
    const hero = getSignupHero();
    if (!hero) return;
    hero.style.display = 'none';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('sign_up') ) {
      openSignupHero();
    }

    document.addEventListener('click', function (e) {
      const button = e.target.closest('.sign_up, .Waitlist');
      if (button) {
        e.preventDefault();
        openSignupHero();
        return;
      }
    });

    setTimeout(() => {
  if (!localStorage.getItem("waitlist_popup_shown")) {
    openSignupHero();
    localStorage.setItem("waitlist_popup_shown", "true");
  }
}, 500);
    
  });
})();

document.querySelector(".waitlist-step-form")
  ?.addEventListener("click", function (e) {
    if (e.target === this) {
      this.style.display = "none";
    }
  });